import React, { useState } from 'react';
import { Box, Flex, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import AnalysisFilterActions from './AnalysisFilterActions';

interface Facility {
  id: string;
  name: string;
}

interface FacilityFilterProps {
  facilities: Facility[];
  onCancel: () => void;
  onApply: (facilityId: string) => void;
  initialSelectedId?: string;
}

const FacilityFilter: React.FC<FacilityFilterProps> = ({ 
  facilities, 
  onCancel, 
  onApply,
  initialSelectedId = ''
}) => {
  const [selectedFacility, setSelectedFacility] = useState(initialSelectedId);

  const handleApply = () => {
    if (selectedFacility) {
      onApply(selectedFacility);
    }
  };

  return (
    <Flex flexFlow="column" justifyContent="space-between" alignItems="center">
      <Box width="460px" height="276px" overflowY="auto" bg="white" borderRadius="10px">
        <RadioGroup 
          onChange={setSelectedFacility} 
          value={selectedFacility}
        >
          <Stack spacing={0}>
            {facilities.map((facility, index) => (
              <Box 
                key={facility.id}
                borderBottom={index < facilities.length - 1 ? "1px solid #DCDCDC" : "none"}
                px="15px"
              >
                <Radio 
                  value={facility.id}
                  size="lg"
                  colorScheme="alea"
                  height="50px"
                  width="100%"
                  display="flex"
                  alignItems="center"
                >
                  <Text 
                    color="alea.500" 
                    fontSize="18px" 
                    fontWeight={selectedFacility === facility.id ? 500 : 400} 
                    lineHeight="100%"
                  >
                    {facility.name}
                  </Text>
                </Radio>
              </Box>
            ))}
          </Stack>
        </RadioGroup>
      </Box>

      <AnalysisFilterActions onCancel={onCancel} onApply={handleApply} />
    </Flex>
  );
};

export default FacilityFilter; 